class Order {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    $('.js-tab-trigger button').on('click', function(e){
      e.preventDefault();
      $(this).addClass('is-active').siblings().removeClass('is-active');
      $('.js-tab-content .js-kinds-sec').eq($(this).index()).show();
      $('.js-tab-content .js-kinds-sec').eq($(this).index()).siblings().hide();
    });
  }
}
